import { WidgetSettings } from "assets/icons/Common";
import { Row } from "components/primitives";
import { activeImage } from "components/widgets/Image/ImageLibrary";
import { DashboardContext } from "contexts/DashboardContext";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { WidgetFC } from "types/Widget";

export interface ImageWidgetState {
  activeWidgetId: string;
  activeImage: string | undefined;
}

export const Image: WidgetFC<ImageWidgetState> = ({
  widgetId,
  state: {},
  settings: {},
  setState,
  onOpenSettings,
}) => {
  const {
    data: { activeImages },
  } = useContext(DashboardContext);
  const [activeImage, setActiveImage] = useState<activeImage | undefined>(
    activeImages?.find((item: activeImage) => item.widgetId === widgetId),
  );

  useEffect(() => {
    setState({ activeWidgetId: widgetId, activeImage: activeImage?.imgurl });
  }, []);

  useEffect(() => {
    if (
      activeImages?.find((item: activeImage) => item.widgetId === widgetId)?.imgurl !==
      activeImage?.imgurl
    ) {
      setActiveImage(activeImages?.find((item: activeImage) => item.widgetId === widgetId));
    }
    setState({
      activeWidgetId: widgetId,
      activeImage: activeImages?.find((item: activeImage) => item.widgetId === widgetId)?.imgurl,
    });
  }, [activeImages]);

  if (activeImage) {
    return (
      <img
        src={activeImage.imgurl}
        alt="image"
        style={{
          objectFit: "contain",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          borderRadius: "0.5rem",
        }}
      />
    );
  }

  return (
    <NoContentContainer>
      Open
      <TextBtn onClick={onOpenSettings}>
        <WidgetSettings width={"1em"} height={"1em"} /> <b>Settings</b>
      </TextBtn>
    </NoContentContainer>
  );
};

const NoContentContainer = styled(Row)`
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 5cqw;
`;

const TextBtn = styled.button`
  border: none;
  box-shadow: none;
  background-color: transparent;
  display: flex;
  color: var(--widget-primary);
  align-items: center;
  padding: 0 5px;
  gap: 5px;
`;
